import { render, staticRenderFns } from "./vat-edit-modal.vue?vue&type=template&id=3299661d&"
import script from "./vat-edit-modal.vue?vue&type=script&lang=js&"
export * from "./vat-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports